/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { XMLParser } from "fast-xml-parser";
import type { BareFetcher, SWRConfiguration } from "swr";
import useSWR from "swr";
import * as v from "valibot";
import { RSSItemSchema, type IRSSItem } from "@/models/rss-item";
import { filterUndefined } from "@/utils/filter-undefined";
import { AppError } from "@/models/appError";

export const getRSSFeed = async (feedUrl: string) => {
  const parser = new XMLParser({
    ignoreAttributes: false, // 属性を保持する
    parseAttributeValue: true, // 属性の値をパースする
    cdataPropName: "__cdata", // CDATAセクションのプロパティ名 (任意)
    removeNSPrefix: true, // 名前空間プレフィックスを削除する (dc:creator -> creator)
  });

  const data = await fetch(feedUrl);
  const response = await data.text();

  const parsed = await parser.parse(response);

  const parsedItems = parsed?.rss?.channel?.item;
  if (!parsedItems || !Array.isArray(parsedItems)) {
    throw new Error("Invalid RSS feed format");
  }

  const items = parsedItems
    .map((item): IRSSItem | undefined => {
      const imagePath = item.thumbnail?.["@_url"];
      const thumbnailUrl = imagePath
        ? `https://teller.jp${imagePath}`
        : undefined;

      const linkUrl = item.link ? new URL(item.link) : undefined;
      const link = linkUrl
        ? `${linkUrl.protocol}//teller.jp${linkUrl.pathname}`
        : undefined;

      const result = v.safeParse(RSSItemSchema, {
        title: item.title ?? "",
        thumbnailUrl: thumbnailUrl,
        date: new Date(item.pubDate ?? ""),
        link: link ?? "",
      });

      return result.success ? result.output : undefined;
    })
    .filter(filterUndefined);

  //   console.log(items);
  return items;
};

const SWR_KEY = "rss-feed-key";

type Data = IRSSItem[];
type SWRError = AppError;

type Params = {
  config?: Partial<SWRConfiguration<Data, SWRError, BareFetcher<Data>>>;
};

const MORE_RSS_FEED_URL = `https://${process.env.REACT_APP_WEB_DOMAIN}/more/feed/`;

export const useFetchMoreRSS = ({ config }: Params = {}) => {
  return useSWR<Data, SWRError>(
    [SWR_KEY],
    () => getRSSFeed(MORE_RSS_FEED_URL),
    config,
  );
};
